<template>
  <div class="loading">
    <template v-for="item in 5" :key="item">
      <van-row class="loading_row">
        <van-col span="24">
          <van-skeleton title :row="8" />
        </van-col>
      </van-row>
    </template>
  </div>
</template>

<style scoped>
.loading_row {
  margin-top: 0.533333rem;
}
</style>



